import { render } from "./RegionProductsModalGlobalInjector.vue?vue&type=template&id=7dbb8cf4&ts=true"
import script from "./RegionProductsModalGlobalInjector.vue?vue&type=script&lang=ts"
export * from "./RegionProductsModalGlobalInjector.vue?vue&type=script&lang=ts"

import exportComponent from "C:\\Users\\groeger\\buggyfit\\buggyfit\\frontend\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__